import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const PaymentBridge = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);

  const merchantTransactionId = params.get("transactionId");

  // ✅ fallback from localStorage
  const caseId =
    params.get("cd_Case_ID") || localStorage.getItem("caseId");

  const token =
    sessionStorage.getItem("pp_token") || localStorage.getItem("pp_token");

  console.log("DEBUG:", {
    merchantTransactionId,
    caseId,
    token,
  });

  useEffect(() => {
    if (!merchantTransactionId || !token || !caseId) {
      console.error("Missing data:", {
        merchantTransactionId,
        token,
        caseId,
      });
      return;
    }

    const interval = setInterval(async () => {
      try {
        const statusResponse = await axios.post(
          "https://clevdoc-legal-887efca919bb.herokuapp.com/v1/payment/v2-order-status",
          {
            userTransactionId: merchantTransactionId,
            cd_Case_ID: caseId,
          },
          {
            headers: {
              Authorization: `O-Bearer ${token}`,
            },
          }
        );

        const status = statusResponse.data.state;

        console.log("Payment status:", status);

        if (status === "COMPLETED") {
          clearInterval(interval);

          sessionStorage.removeItem("pp_token");

          console.log("Redirecting with caseId:", caseId);

          window.location.href =
            `https://legal.uat.clevdoc.com/payment-Process?transactionId=${merchantTransactionId}&cd_Case_ID=${caseId}`;
        }

        if (status === "FAILED") {
          clearInterval(interval);

          alert("Payment failed");

          navigate(
            `/legal-payment?status=failed&msg=${encodeURIComponent(
              "Payment failed, please try again"
            )}`
          );
        }
      } catch (err) {
        console.error("Status check error:", err);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [merchantTransactionId, token, caseId, navigate]);

  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <h1 className="text-3xl font-semibold text-green-600">
        Confirming Payment
      </h1>
      <p className="mt-4 text-gray-600 text-lg">
        Please wait while we confirm your payment...
      </p>
      <div className="mt-8 w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default PaymentBridge;